export default __webpack_public_path__ + "static/media/Path3503.5ff88f54.svg";